var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSailTrackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 390.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--logoPrimary, #dedcc6)",
    d: "m139,237.68c9.15-10.17,16.58-21.56,23.52-33.29,16.75-28.31,26.76-58.94,31.38-91.4,1.75-12.31,2.77-24.68,2.2-37.7,4.15,2.17,7.39,4.94,10.72,7.51,31.47,24.31,53.25,55.43,65.37,93.31,6.45,20.16,10.75,40.76,12.52,61.87.35,4.2.72,8.41,1.25,12.6.26,2.05-.37,2.69-2.42,2.88-12.48,1.13-24.96,2.36-37.43,3.62-20.99,2.12-41.98,4.27-62.96,6.44-21.34,2.21-42.68,4.44-64.02,6.68-3.23.34-6.46.67-9.67,1.16-.75.11-2.46.35-1.87-.28s1.51-1.59,1.93-2.06c1.24-1.37,2.04-2.2,3.42-3.55,3.07-3.03,5.64-5.75,8.39-8.69,5.45-5.84,10.34-10.81,15.68-16.74.48-.53,1.6-1.79,2.01-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--logoPrimary, #dedcc6)",
    d: "m105.44,291.09s-2.01-.42-2.17-.52c60.91-4.4,121.56-12.05,182.55-16.55-10.85,7.98-21.63,15.91-31.74,24.64-4.65,4.02-9.3,4.68-15.12,4.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailTrackLogo);
export default __webpack_public_path__ + "static/media/SailTrackLogo.1cbf3e72c2921bac1c2b2e579a4d1e51.svg";
export { ForwardRef as ReactComponent };